module.exports = __webpack_public_path__ + "img/illustrationicon-sb-ottoman-recliner-boutique-48x48.00f59ed.svg";